import React from "react";
import './CompanyProfile.css';
import building from "./assets/ComBuild.png";
import office from "./assets/team.png";
import globe from "./assets/companyGlobe.png";
import inspection from "./assets/inspection.png";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import vision from "./assets/vision.png";
import mission from "./assets/mission.png";
import values from "./assets/Values.png";


const CompanyProfile = () => {
    return (
        <>
            <div className="row">
                {/* Middle Column */}
                <div className="col-lg-12 col-md-12 col-sm-12 middlecol container">
                    <div className="row combanner">
                        <h2>Company Profile</h2>
                        <div className="col-lg-12">
                            <img src={building} alt="MI Building" className="mainprofile img-fluid" />
                        </div>
                        <div className="col-lg-12 mt-3 maincolprofile">
                            <p>MI Trading Japan, since 1999 Exporting Quality & Affordable Japanese Used Cars, we meet the
                                needs of customers from over 200 countries around the world. We are one of the largest
                                Exporters of used vehicles in Japan and we offer a wide range of models and makes,
                                professionally inspected and maintained.<br></br><br></br>
                                We are proud to be respected as a truly global company. The foundation of our success can be
                                credited to our strategy of capitalizing one single market at a time through growth and
                                penetration.                              
                            </p>
                        </div>
                    </div>

                    <div className="row comrow combanner">
                        <div className="col-lg-4 col-md-12">
                            <img src={office} alt="MI Office" className="miteam img-fluid" />
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <p>Official membership of over 120+ Auction houses here within Japan. Covering all of the Used
                                Vehicles Auction Houses allows MI Trading Japan to ensure the cheapest prices within all of
                                the Competitors/Exporters in Japan.<br></br><br></br></p>
                        </div>
                    </div>

                    <div className="row comrow combanner">                        
                        <div className="col-lg-8 col-md-12">
                            <p>Our corporate strength comes from providing to the demands of a global market with services
                                ranging from sales, transport, reliable remittance procedures and delivery to local customers.
                                We furthermore expanding our Business providing Vehicles from Thailand, Dubai & Singapore.</p>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <img src={globe} alt="MI Office" className="miteam img-fluid" />
                        </div>
                    </div>

                    <div className="row comrow combanner">
                        <div className="col-lg-4 col-md-12">
                            <img src={inspection} alt="MI Office" className="miteam img-fluid" />
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <p>
                                "Our headquarters are based in Japan, where all our core operations are carried out. Our
                                dedicated sales office is located in Pakistan, managing all sales transactions, invoicing, and
                                auctions to ensure seamless service delivery."</p>
                        </div>
                    </div>

                    <div className="col-lg-12 comtable py-5">
                        <h2>CORPORATE DETAILS:</h2>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">COMPANY NAME</th>
                                    <td scope="col">M.I TRADING CO LTD JAPAN</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">PRESIDENT & CEO</th>
                                    <td>MUHAMMAD RAFIQ</td>
                                </tr>
                                <tr>
                                    <th scope="row">ADDRESS</th>
                                    <td>315-0131 IBARAKI KEN ISHIOKA SHI SHIMOBAYASHI 3290-1, Kantō, Japan</td>
                                </tr>
                                <tr>
                                    <th scope="row">POSTAL CODE</th>
                                    <td>3290-1</td>
                                </tr>
                                <tr>
                                    <th scope="row">PHONE</th>
                                    <td>+81 90-5342-1744</td>
                                </tr>
                                <tr>
                                    <th scope="row">WHATSAPP</th>
                                    <td>+81 90-8100-0786</td>
                                </tr>
                                <tr>
                                    <th scope="row">FAX</th>
                                    <td>0299-56-4954</td>
                                </tr>
                                <tr>
                                    <th scope="row">CORPORATE SITE</th>
                                    <td>https://mitradingjp.com</td>
                                </tr>
                                <tr>
                                    <th scope="row">E-MAIL ADDRESS</th>
                                    <td>info@mitradingjp.com</td>
                                </tr>
                                <tr>
                                    <th scope="row">YEAR ESTABLISHED</th>
                                    <td>2014</td>
                                </tr>
                                <tr>
                                    <th scope="row">BUSINESS DESCRIPTION</th>
                                    <td>Export & Sale of New & Used Automobiles</td>
                                </tr>
                                <tr>
                                    <th scope="row">BANK</th>
                                    <td>MUFG BANK JAPAN</td>
                                </tr>
                                <tr>
                                    <th scope="row">LANGUAGE SPOKEN</th>
                                    <td>ENGLISH, JAPANESE, URDU, BENGALI, HINDI</td>
                                </tr>
                                <tr>
                                    <th scope="row">OFFICE</th>
                                    <td>(1) Headoffice in Japan & (1) Sales Office in Pakistan</td>
                                </tr>
                                <tr>
                                    <th scope="row">NUMBER OF EMPLOYEES</th>
                                    <td>150+ EMPLOYEES CURRENTLY WORKING IN BOTH OFFICES</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="row comrow miss-vis">
                        <div className="col-lg-3 col-md-12">
                            <img src={vision} alt="Vision" className="mimission img-fluid" />
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <p>Since our inception, we’ve grown by embracing innovative ideas, advanced technologies, and robust systems. Our customers can easily browse and select vehicles from our inventory using our powerful search engine.</p>
                        </div>
                        <div className="col-lg-3 col-md-12 mt-3">
                            <img src={mission} alt="Mission" className="mimission img-fluid" />
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <p>With sales offices around the globe and 24/7 customer service centers, we are always here to assist with your purchasing process. We are committed to continuous improvement and strive to exceed customer expectations by providing exceptional service at every step.</p>
                        </div>
                        <div className="col-lg-3 col-md-12 mt-3">
                            <img src={values} alt="Mission" className="mimission img-fluid" />
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <p>Our group is committed to delivering exceptional auction services by expanding a network of auction houses and inspection units across Japan. We uphold the highest quality standards to provide our customers with the best vehicles and ensure their complete satisfaction.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompanyProfile;